@if (videos.length > 0) {
  <h3 class="mb-3">Training Videos</h3>
}
<div class="row">
  @for (video of filteredVideos; track video) {
    <app-video-card
      class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3"
      [video]="video"
      (playAction)="videoSelected($event)"
    >
    </app-video-card>
  }
</div>
@if (showLoadMoreBtn) {
  <div class="load-more">
    <kehe-phoenix-button (click)="loadMore()" classAttr="btn btn-secondary">{{
      loadMoreText
    }}</kehe-phoenix-button>
  </div>
}
